import { render, staticRenderFns } from "./customer-detial.vue?vue&type=template&id=6292c770&scoped=true"
import script from "./customer-detial.vue?vue&type=script&lang=js"
export * from "./customer-detial.vue?vue&type=script&lang=js"
import style0 from "./customer-detial.vue?vue&type=style&index=0&id=6292c770&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292c770",
  null
  
)

export default component.exports